import { BuyNowPayLaterConfig } from "~features/checkout/checkout.types";
import { FeeType } from "~graphql/sdk";

export type OmitTypename<T> = Omit<T, "__typename">;

type optionsConfig = {
  fee?: number | null;
  type?: FeeType | null;
  showHiddenFees?: boolean;
};

export const calculateBNPLPrice = (
  total: number,
  config: BuyNowPayLaterConfig,
  options: optionsConfig = {}
): number => {
  let fee = 0;

  if (options.showHiddenFees && options.fee) {
    if (options.type === FeeType.Percentage) {
      fee = total * (options.fee / 100);
    } else {
      fee = options.fee;
    }
  }

  return (total + fee) / config.terms;
};

export const isChilliPeppersGAToSeatedHack = (eventId: string): boolean => {
  // https://app.shortcut.com/flicket-ltd/story/6514/chill-peppers-hack
  return [
    "9451b8e2-fb7d-4a2e-b664-068829ee2858",
    "5e8750f1-e6ae-4aea-a2f3-1f0976b154aa",
    "9d0cf588-0963-49a4-8faf-d7305a0b2f12",
    "4c512782-d80a-4179-8af1-1504e5cce788",
    "3860c583-0fcd-4acd-bceb-9361651bbfc6",
    "ed98487b-7349-4549-9626-2fba3d8f7584",
    "b497724d-4022-4fae-aaa0-d33e1506c8ad",
    "38109049-ada7-4558-be6a-94af38c6fad6",
    "4b5bb399-ad52-477b-bd64-cf1889df7cd6",
    "1bc30cd4-bdf6-4ad1-b341-45f70a36ae4a",
    "7468aafb-be55-4a66-870e-62bd7fb04785",
    "3aa28d92-fa97-47cf-81fd-343d90ff65c1",
    "4fce3d91-a2a5-4553-af70-03b6ee3be936",
  ].includes(eventId);
};
